import { Component, EventEmitter, Input, Output, TemplateRef } from "@angular/core";
import { NgClassType } from "../../../types";

import { MedTableTemplates } from "../types.local";
import { SORT_DIRECTIONS } from "../constants/sortDirections";
import { MedTableColumnConfig, MedTableSortEvent } from "../types";
import { TABLE_HEAD_CELL_TEMPLATE_PREFIX, TABLE_HEAD_CELL_TEMPLATE } from "../constants/prefixes";

@Component({
  selector: "med-table-head-cell",
  templateUrl: "./med-table-head-cell.component.html",
  styleUrls: ["./med-table-head-cell.component.scss"],
})
export class MedTableHeadCellComponent {
  @Input() column!: MedTableColumnConfig;
  @Input() templates?: MedTableTemplates;
  @Input() sort?: MedTableSortEvent | null;

  @Output() sortChange = new EventEmitter<MedTableSortEvent | null>();

  get isSorting(): boolean {
    const { key } = this.column;
    const { direction, key: sortKey } = this.sort || {};
    return sortKey === key && Boolean(direction);
  }

  get isAscSorting(): boolean {
    return this.sort?.direction === SORT_DIRECTIONS.ASC;
  }

  get classList(): NgClassType {
    return {
      "sorting": this.isSorting,
      "sortable": this.column.sortable,
      "asc": this.isSorting && this.isAscSorting,
      [this.column.headCellClass || ""]: this.column.headCellClass,
    };
  }

  get template(): TemplateRef<any> | null {
    return this.templates?.[`${TABLE_HEAD_CELL_TEMPLATE_PREFIX}${this.column.key}`]
      || this.templates?.[TABLE_HEAD_CELL_TEMPLATE] || null;
  }

  onSort(): void {
    if (!this.column.sortable) {
      return;
    }

    const { key } = this.column;
    const sorting = this.isSorting ? this.sort?.direction : null;

    switch (sorting) {
    case SORT_DIRECTIONS.ASC:
      return this.sortChange.emit(null);
    case SORT_DIRECTIONS.DESC:
      return this.sortChange.emit({
        key,
        direction: SORT_DIRECTIONS.ASC,
      });
    default:
      return this.sortChange.emit({
        key,
        direction: SORT_DIRECTIONS.DESC,
      });
    }
  }
}
